import { get } from 'lodash-es';

const byTotalHits = (state: any) => get(state, 'resultList.totalHits');

export default byTotalHits;
